import {V3Record} from 'data/helpers/V3Record.js'
import {trackpointMetrics} from 'lib/metricsCalculator'

const readOnly = [
  'administrativeArea',
  'avgCad',
  'avgHr',
  'avgPowerEstimated',
  'avgSpeed',
  'avgWatts',
  'boundingBox',
  'bylineName',
  'bylinePath',
  'coursePoints',
  'calories',
  'createdAt',
  'departedAt',
  'distance',
  'elevationGain',
  'elevationLoss',
  'excludeFromTotals',
  'gearName',
  'highlightedPhotoId',
  'hrZones',
  'isStationary',
  'lapSummaries',
  'locality',
  'maxCad',
  'maxHr',
  'metrics',
  'minCad',
  'minHr',
  'movingPace',
  'movingTime',
  'movingTimeSeconds',
  'navId',
  'navType',
  'navName',
  'pace',
  'poiIds',
  'photoIds',
  'photos',
  'postalCode',
  'privacyCode',
  'rawPoints',
  'updatedAt',
  'userId'
]

export const Trip = V3Record('trip', {
  administrativeArea: null,
  avgCad: null,
  avgHr: null,
  avgPowerEstimated: null,
  avgSpeed: null,
  avgWatts: null,
  boundingBox: null,
  bylineName: null,
  bylinePath: null,
  calories: null,
  coursePoints: [],
  createdAt: null,
  departedAt: null,
  duration: null,
  description: null,
  distance: null,
  elevationGain: null,
  elevationLoss: null,
  excludeFromTotals: null,
  gearId: null,
  gearName: '',
  highlightedPhotoId: null,
  hrZones: null,
  isStationary: null,
  lapSummaries: null,
  locality: null,
  maxCad: null,
  maxHr: null,
  metrics: null,
  minCad: null,
  minHr: null,
  movingPace: null,
  movingTime: null,
  movingTimeSeconds: null,
  navId: null,
  navType: null,
  navName: null,
  name: null,
  pace: null,
  photoIds: [],
  photos: [],
  poiIds: [],
  pointsOfInterest: [],
  postalCode: null,
  privacyCode: null,
  rawPoints: [],
  trackPoints: [],
  updatedAt: null,
  userId: null,
  visibility: 0
}, {readOnly})

Trip.defaultDeserialize = Trip.deserialize
Trip.defaultSerialize = Trip.serialize
Trip.deserialize = (fromRails) => {
  const trip = Trip.defaultDeserialize(fromRails)
  return trip
    .set('rawPoints', trip.trackPoints)
    .set('trackPoints', trip.trackPoints ? trackpointMetrics(trip.trackPoints) : null)
}

Trip.serialize = (toRails) => {
  const response = Trip.defaultSerialize(toRails)
  // reverse the above operation
  delete response.trip.raw_points
  response.trip.track_points = JSON.stringify(toRails.rawPoints)
  return response
}
